import React from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

import { userPropTypes } from 'helpers/propTypes';

import './TopNavTextil.scss';

const TopNavTextil = (props) => {
  const {
    logout, openLoginModal, openRegisterModal, user, client,
  } = props;

  return (
    
    <div className={`top-nav`} data-testid="topnav">
      <div className="container fill-height">
        <div className="row top-nav-content fill-height">
          <div className="col-md-4 top-nav-info text-center">
            <span className="top-nav-item">Envios a todo el pais</span>
          </div>
        </div>
      </div>
    </div>
  );
};

TopNavTextil.defaultProps = {
  user: null,
};

TopNavTextil.propTypes = {
  logout: PropTypes.func.isRequired,
  openLoginModal: PropTypes.func.isRequired,
  openRegisterModal: PropTypes.func.isRequired,
  user: userPropTypes,
};

export default TopNavTextil;
